
export const checkIsTrialOver = (busState) => {

  //checks whether it IS trial, and whether it's over or not,
  //returns { isTrial: .., isOver:.., daysLeft:...  }

  let toReturn = {
    isTrial: false
  }

  if (typeof busState.subStatusOK === 'undefined') {
    //it's trial
    var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    let nowDate = new Date()
    let timeCreated = busState.dateCreated * 1000
    var diffDays = Math.round((nowDate.getTime() - ( timeCreated )) / (oneDay));
    let daysLeft =  14 - diffDays

    toReturn.isTrial = true
    toReturn.isOver = true
    toReturn.daysLeft = daysLeft
  }

  return toReturn

}
